module.exports = {"body":"<h1 id=\"lost-in-the-void\" class='hero title'><a href=\"#lost-in-the-void\" class='Cur(d)!'>LOST IN THE VOID</a></h1><blockquote class=\"quote\">\n<p class='paragraph'>The void may seem endless in it&#39;s merciless pursuit to consume the stars. Let despair become hope, for even the void cannot deny this fathomless truth. When the darkness swallows the stars, the void will once again surrender to the light.</p></blockquote>\n"}


//////////////////
// WEBPACK FOOTER
// ./404.md
// module id = 574
// module chunks = 0